import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default () => new Promise((resolve) => {
  const brandedImgData = {
    object: 'image',
    action: 'read',
    server: window.location.hostname,
    filename: 'portal_landing.png', // branded image has priority
  };

  nsApi.getLogo(brandedImgData).then((res) => {
    resolve(res);
  }).catch(() => {
    resolve(false);
  });
});
